// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.restoration-overlay {
  position: fixed;
  inset: 0;
  background: rgba(7, 13, 24, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  backdrop-filter: blur(8px);
}

.restoration-dialog {
  background: var(--vb-surface);
  color: var(--vb-text);
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius-lg);
  padding: 24px;
  max-width: 500px;
  width: 100%;
  box-shadow: var(--vb-shadow-lg);
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from { transform: translateY(-16px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.restoration-header {
  text-align: center;
  margin-bottom: 18px;
}

.restoration-header h3 {
  margin: 0 0 6px;
  font-size: 20px;
  font-weight: 800;
}

.restoration-header p {
  margin: 0;
  color: var(--vb-text-muted);
  font-size: 14px;
}

.restoration-preview {
  background: var(--vb-surface-2);
  border-radius: var(--vb-radius);
  padding: 16px;
  margin-bottom: 18px;
  border: 1px solid var(--vb-border);
}

.match-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 14px;
}

.team-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.restoration-dialog .team-name {
  font-weight: 700;
  font-size: 15px;
}

.restoration-dialog .score {
  font-family: var(--vb-font-score);
  font-size: 36px;
  font-weight: 800;
  color: var(--vb-text);
  background: var(--vb-surface);
  padding: 6px 14px;
  border-radius: 12px;
  border: 1px solid var(--vb-border);
  min-width: 56px;
  text-align: center;
}

.vs {
  font-weight: 800;
  color: var(--vb-text-muted);
}

.match-details {
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}

.detail-item .label { color: var(--vb-text-muted); font-weight: 600; }
.detail-item .value { font-weight: 700; }

.restoration-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-bottom: 14px;
}

.restore-btn,
.discard-btn {
  padding: 12px 20px;
  border: none;
  border-radius: var(--vb-radius-sm);
  font-size: 15px;
  font-weight: 750;
  cursor: pointer;
  min-width: 140px;
}

.restore-btn {
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
}

.discard-btn {
  background: var(--vb-surface-2);
  color: var(--vb-text);
  border: 1px solid var(--vb-border);
}

.restoration-note {
  text-align: center;
  padding: 12px;
  background: var(--vb-primary-soft);
  border-radius: 10px;
}

.restoration-note small {
  color: var(--vb-text);
  font-size: 12px;
}

@media (max-width: 768px) {
  .restoration-actions { flex-direction: column; }
  .restore-btn, .discard-btn { width: 100%; min-width: 0; }
}
`, "",{"version":3,"sources":["webpack://./src/components/StateRestorationDialog.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;EAClC,kCAAkC;EAClC,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA,sBAAsB,2BAA2B,EAAE,gBAAgB,EAAE;AACrE,sBAAsB,gBAAgB,EAAE;;AAExC;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,uBAAuB,sBAAsB,EAAE;EAC/C,6BAA6B,WAAW,EAAE,YAAY,EAAE;AAC1D","sourcesContent":[".restoration-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(7, 13, 24, 0.72);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n  backdrop-filter: blur(8px);\n}\n\n.restoration-dialog {\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius-lg);\n  padding: 24px;\n  max-width: 500px;\n  width: 100%;\n  box-shadow: var(--vb-shadow-lg);\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-16px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.restoration-header {\n  text-align: center;\n  margin-bottom: 18px;\n}\n\n.restoration-header h3 {\n  margin: 0 0 6px;\n  font-size: 20px;\n  font-weight: 800;\n}\n\n.restoration-header p {\n  margin: 0;\n  color: var(--vb-text-muted);\n  font-size: 14px;\n}\n\n.restoration-preview {\n  background: var(--vb-surface-2);\n  border-radius: var(--vb-radius);\n  padding: 16px;\n  margin-bottom: 18px;\n  border: 1px solid var(--vb-border);\n}\n\n.match-preview {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 14px;\n}\n\n.team-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.restoration-dialog .team-name {\n  font-weight: 700;\n  font-size: 15px;\n}\n\n.restoration-dialog .score {\n  font-family: var(--vb-font-score);\n  font-size: 36px;\n  font-weight: 800;\n  color: var(--vb-text);\n  background: var(--vb-surface);\n  padding: 6px 14px;\n  border-radius: 12px;\n  border: 1px solid var(--vb-border);\n  min-width: 56px;\n  text-align: center;\n}\n\n.vs {\n  font-weight: 800;\n  color: var(--vb-text-muted);\n}\n\n.match-details {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.detail-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n}\n\n.detail-item .label { color: var(--vb-text-muted); font-weight: 600; }\n.detail-item .value { font-weight: 700; }\n\n.restoration-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  margin-bottom: 14px;\n}\n\n.restore-btn,\n.discard-btn {\n  padding: 12px 20px;\n  border: none;\n  border-radius: var(--vb-radius-sm);\n  font-size: 15px;\n  font-weight: 750;\n  cursor: pointer;\n  min-width: 140px;\n}\n\n.restore-btn {\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n}\n\n.discard-btn {\n  background: var(--vb-surface-2);\n  color: var(--vb-text);\n  border: 1px solid var(--vb-border);\n}\n\n.restoration-note {\n  text-align: center;\n  padding: 12px;\n  background: var(--vb-primary-soft);\n  border-radius: 10px;\n}\n\n.restoration-note small {\n  color: var(--vb-text);\n  font-size: 12px;\n}\n\n@media (max-width: 768px) {\n  .restoration-actions { flex-direction: column; }\n  .restore-btn, .discard-btn { width: 100%; min-width: 0; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
